import React,{useState,useRef,useEffect} from 'react';
import {BsArrowLeftCircle,BsArrowRightCircle} from 'react-icons/bs';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import CountUp from 'react-countup';
import { Link } from "react-router-dom";

// clients 

import client1 from '../images/clients/1.png';
import client2 from '../images/clients/2.png';
import client3 from '../images/clients/3.png';
import client4 from '../images/clients/4.png';
import client5 from '../images/clients/5.png';
import client6 from '../images/clients/6.png';
import client7 from '../images/clients/7.png';
import client8 from '../images/clients/8.png';
import client9 from '../images/clients/9.png';
import client10 from '../images/clients/10.png';
import client11 from '../images/clients/11.png';
import client12 from '../images/clients/12.png';
import client13 from '../images/clients/13.png';
import client14 from '../images/clients/14.png';
import client15 from '../images/clients/15.png';
import client16 from '../images/clients/16.png';
import client17 from '../images/clients/17.png';
import client18 from '../images/clients/18.png';
import client19 from '../images/clients/19.png';
import client20 from '../images/clients/20.png';
import client21 from '../images/clients/21.png';
import client22 from '../images/clients/22.png';
import client23 from '../images/clients/23.png';
import client24 from '../images/clients/24.png';
import client25 from '../images/clients/25.png';
import client26 from '../images/clients/26.png';
import client27 from '../images/clients/27.png';
import client28 from '../images/clients/28.png';
import client29 from '../images/clients/29.png';
import client30 from '../images/clients/30.png';
import client31 from '../images/clients/31.png';
import client32 from '../images/clients/32.png';
import client33 from '../images/clients/33.png';
import client34 from '../images/clients/34.png';
import client35 from '../images/clients/35.png';
import client36 from '../images/clients/36.png';
import client37 from '../images/clients/37.png';
import client38 from '../images/clients/38.png';
import client39 from '../images/clients/39.png';
import client40 from '../images/clients/40.png';
import client41 from '../images/clients/41.png';
import client42 from '../images/clients/42.png';
import client43 from '../images/clients/43.png';
import client44 from '../images/clients/44.png';
import client45 from '../images/clients/45.png';
import client46 from '../images/clients/46.png';
import client47 from '../images/clients/47.png';
import client48 from '../images/clients/48.png';
import client49 from '../images/clients/49.png';
import client50 from '../images/clients/50.png';
import client51 from '../images/clients/51.png';
import client52 from '../images/clients/52.png';

import Slider from "react-slick";

// places 

import health from '../images/industry/Healthcare.png';
import education from '../images/industry/college.png';
import industry from '../images/industry/industrial.png';
import corperate from '../images/industry/corperate.png';
import retial from '../images/industry/industrial.png';
import pharmaceutical from '../images/industry/observation.png';
import bank from '../images/industry/bank.png';
import commercial from '../images/industry/building.png';

import banner1 from '../images/banner/banner1.jpeg'


// stand out

import stand1 from '../images/stand_out/service_offering.png'
import stand2 from '../images/stand_out/experienced_professionals.png'
import stand3 from '../images/stand_out/hassle_execution.png'
import stand4 from '../images/stand_out/diverse_offering.png'
import stand5 from '../images/stand_out/client_testimonials.png'


// services

import ss from '../images/services/ss.png';
import hs from '../images/services/hs.png';
import se from '../images/services/se.png';

//sections

import section1 from '../images/section/infrastructure.png'
import section2 from '../images/section/public-relation.png'
import section3 from '../images/section/places.png'
import section4 from '../images/section/like.png'


//certificated 

import cert1 from '../images/certificate/9001.jpg'
import cert2 from '../images/certificate/14001.jpg'
import cert3 from '../images/certificate/27001.jpg'
import cert4 from '../images/certificate/45001.jpg'
import cert5 from '../images/certificate/50001.jpg'
import cert6 from '../images/certificate/CLRA.jpg'
import cert7 from '../images/certificate/FCPLPsara.jpg'
import cert8 from '../images/certificate/LICENSE CERTIFICATE.jpg'
import cert9 from '../images/certificate/Sanitary.jpg'
// import cert1 from '../../images/certificate/9001.pdf'
// import cert1 from '../../images/certificate/9001.pdf'

import about from '../images/fidelitus.jpeg'


import {IoIosArrowBack,IoIosArrowForward} from 'react-icons/io';
import {FiPlusCircle} from 'react-icons/fi';

import Typist from 'react-typist';
import { useNavigate } from 'react-router-dom';

import videoPlay from '../images/video.mp4'
import toast from 'react-hot-toast';

function Home() {
 
      const videoRef = useRef(null);

      const navigator = useNavigate() 
      const images = [banner1]

      const [step,setstep] = useState(0)

      useEffect(() => {
        const video = videoRef.current;
        if (video) {
          // Attempt to play the video
          video.play().catch(error => {
           toast.error("Oops we couldn't play the video for you!")
  
            // Handle error (e.g., show a play button)
            console.log('Autoplay prevented. Showing play button.');
          });
        }
    }, []);
  
      const services = [
        {
          img:ss,
          name:'Housekeeping Services',
          val:'Maintaining clean, hygienic, and productive environments.'
        },
        {
          img:hs,
          name:'Maintenance Services',
          val:'Efficient technical support for uninterrupted operations.'
        },
        {
          img:se,
          name:'Security Services',
          val:'Professional security personnel ensuring safety and vigilance'
        },
      ]

      


      const testimonials = [
        {
          id:1,
          name:"Melvin D'Souza",
          company:'MAVERIK',
          testimonial:'We are associated with Fidelitus Corp Integrated Facility Services for last one year and we are very happy to recommend you to any other companies and very happy with your all services like security, housekeeping, and other highlight services with the team.',
          img:client52,
          date:'12 May 2022'
        },
        {
          id:3,
          name:'Sundari Rajan',
          company:'Colive',
          testimonial:'I have mention that over the last two years which probably are of the worst time of us Fidelitus FMS stood by us during the covid time shown a lot of solidarity and support will working with the team and also been very proactive in the team of approach support the great credit goes to Ms. Shubhalaxmi and entire team who is work very closely with our team to makesure of successful partnership, we are look for long association with them. Great work Fidelitus.',
          img:client39,
          date:'14 Jan 2023'
        },
        {
          id:2,
          name:'Raghav Suvarna',
          company:'Softtek India pvt ltd',
          testimonial:'We are working with Fidelitus Facility team since from 5 years. They are providing discipled service with great team work in our premises. They have very dedicated and competing team. We are happy to associate with Fidelitus Facility Team.',
          img:client1,
          date:'10 Jan 2022'
    
        },
      ]

      const stand_out = [
        {
          img:stand1,
          name:'Customer-Centric Approach',
          val:'Your needs are at the heart of our solutions, ensuring personalized and effective services.'
        },
        {
          img:stand2,
          name:'Experienced Professionals',
          val:'Our team of skilled experts guarantees unmatched proficiency in facility management.'
        },
        {
          img:stand3,
          name:'Hassle-Free Execution',
          val:'We take full responsibility, ensuring smooth operations and minimal disruptions.'
        },
        {
          img:stand4,
          name:'Diverse Service Offerings',
          val:'From security to landscaping, we offer a comprehensive range of facility management solutions.'
        },
        {
          img:stand5,
          name:'Client Testimonials',
          val:'Our satisfied clients speak volumes about the quality of our services and dedication.'
        },
      ]

      const industries = [
         {
            id:1,
            img:health,
            name:'Healthcare'
         },
         {
          id:2,
          img:education,
          name:'Institutional'
         },
         {
          id:3,
          img:industry,
          name:'Industrial'
         },
         {
          id:4,
          img:corperate,
          name:'Corporate'
         },
         {
          id:5,
          img:retial,
          name:'Retail'
         },
         {
          id:6,
          img:commercial,
          name:'Commercial'
         },
        //  {
        //   id:6,
        //   img:'',
        //   name:'Resedential'
        //  },
         {
          id:7,
          img:pharmaceutical,
          name:'Pharmaceutical'
         },
         {
          id:8,
          img:bank,
          name:'Bank'
         },
        //  {
        //   id:9,
        //   img:mall,
        //   name:'Mall'
        //  },

      ]

      const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 100,
        slidesToShow: 6,
        slidesToScroll: 4,
        initialSlide: 0,
        centerMode: true,
        cssEase: "linear",
        autoplaySpeed: 2000,
        centerPadding: '0px',
        autoPlay:true,
        prevArrow:<SampleNextArrow />,
        nextArrow:<SamplePrevArrow />,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              autoPlay:true
             
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              initialSlide: 3,
              autoPlay:true
    
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              initialSlide: 3,
              autoPlay:true
            }
          }
        ]
      };
    
      const settings1 = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 100,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        centerMode: true,
        cssEase: "linear",
        autoplaySpeed: 2000,
        centerPadding: '0px',
        autoPlay:true,
        prevArrow:<SampleNextArrow />,
        nextArrow:<SamplePrevArrow />,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              autoPlay:true
             
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
              autoPlay:true
    
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              autoPlay:true
            }
          }
        ]
      };

     
      function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
        <BsArrowLeftCircle 
        className={`${className} -mt-0  md:-mt-12 `}
        style={{ ...style, display: "block",color:'#ddd',}}
        onClick={onClick} />
        );
      }
      
      function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
          <BsArrowRightCircle 
              className={`${className} -mt-0 md:-mt-12 `}
              style={{ ...style, display: "block",color:'#ddd',}}
              onClick={onClick} />
        );
      }
  
      const clients = [ 
          {
            id:1,
            img:client1
          },
          {
            id:2,
            img:client2      
          },
          {
            id:3,
            img:client3
          },
          {
            id:4,
            img:client4
          },
          {
            id:5,
            img:client5
          },
          {
            id:6,
            img:client6
          },
          {
            id:7,
            img:client7
          },
          {
            id:8,
            img:client8
          },
          {
            id:9,
            img:client9
          },
          {
            id:10,
            img:client10
          },
          {
            id:11,
            img:client11
          },
          {
            id:12,
            img:client12
          },
          {
            id:13,
            img:client13
          },
          {
            id:14,
            img:client14
          },
          {
            id:15,
            img:client15
          },
          {
            id:16,
            img:client16
          },
          {
              id:17,
              img:client17
            },
            {
              id:18,
              img:client18     
            },
            {
              id:19,
              img:client19
            },
            {
              id:20,
              img:client20
            },
            {
              id:21,
              img:client21
            },
            {
              id:22,
              img:client22
            },
            {
              id:23,
              img:client23
            },
            {
              id:24,
              img:client24
            },
            {
              id:25,
              img:client25
            },
            {
              id:26,
              img:client26
            },
            {
              id:27,
              img:client27
            },
            {
              id:28,
              img:client28
            },
            {
              id:29,
              img:client29
            },
            {
              id:30,
              img:client30
            },
            {
              id:31,
              img:client31
            },
            {
              id:32,
              img:client32
            },
            {
              id:33,
              img:client33
            },
            {
              id:34,
              img:client34     
            },
            {
              id:35,
              img:client35
            },
            {
              id:36,
              img:client36
            },
            {
              id:37,
              img:client37
            },
            {
              id:38,
              img:client38
            },
            {
              id:39,
              img:client39
            },
            {
              id:40,
              img:client40
            },
            {
              id:41,
              img:client41
            },
            {
              id:42,
              img:client42
            },
            {
              id:43,
              img:client43
            },
            {
              id:44,
              img:client44
            },
            {
              id:45,
              img:client45
            },
            {
              id:46,
              img:client46
            },
            {
              id:47,
              img:client47
            },
            {
              id:48,
              img:client48
            },
            {
              id:49,
              img:client49
            },
            {
              id:50,
              img:client50
            },
            {
              id:51,
              img:client51
            }
      ]

  return (
    <div className='overflow-hidden max-w-sceen'>
        {/* <Carousel 
            centerMode={true} 
            autoPlay={true} 
            showStatus={false}
            showThumbs={false}
            showArrows={true}
            swipeable={true}
            autoFocus={true}
            centerSlidePercentage={100}
            showIndicators={false}
            className=''
            renderArrowPrev={(clickHandler, hasPrev) => {
              return (
                <div
                  className={`${hasPrev ? "opacity-100" : "opacity-20"} absolute right-[35px] border-r-2 border-gray-100 bottom-0 bg-white  flex justify-center items-center p-2  cursor-pointer z-20`}
                  onClick={clickHandler}
                >
                  <IoIosArrowBack size={20} className="text-black" />
                </div>
              );
            }}
            renderArrowNext={(clickHandler, hasPrev) => {
              return (
                <div
                  className={`${hasPrev ? "opacity-100" : "opacity-20"} absolute right-0 bottom-0 bg-white  flex justify-center items-center p-2  cursor-pointer z-20`}
                  onClick={clickHandler}
                >
                  <IoIosArrowForward size={20} className="text-black" />
                </div>
              );
            }}
          
          >
              {images?.map((c,i)=>(
                  <div key={i} className='text-center relative relative w-[100%] mx-auto focus:outline-none focus:ring-0'>
                     <img alt={c} src={c}  className='w-full h-[35vh] md:h-[92.4vh] object-cover md:object-cover focus:outline-none focus:ring-0 '/>

                     <div data-aos="fade-left" className='border-l-4 border-[#4190ac]  w-[75%]  md:w-[25%] pl-4 absolute top-[10%] right-[5%]'> 
                          <h1 className='text-[20px] text-left font_thicker text-[#e58c3d]'>Fidelitus IFMS  </h1>
                          <h6 className='text-left font_thick font-bold text-[15px] text-white'>A Global Integrated Facility Managment Services Provider</h6>
                          <h6 className='text-left font_normal text-[13px] text-white'>As a recoginized IFMS We are ready to add care to your space</h6>
                     </div>
                  </div>    
               ))}



             

        </Carousel> */}

        <video  ref={videoRef} id="video"  width="100%"  controls={false}  autoPlay playsInline loop muted className="w-full md:h-[90vh] object-cover">
             <source src={videoPlay} type="video/mp4"/> 
              {/* <source src={videoPlay1} type="video/mp4"/> */}
            </video>


        <div className='bg-[#418eaa]  py-10'>
        <div className=' md:border-none grid grid-cols-2 md:grid-cols-4  ml-0 md:px-[10%]   md:mt-0   md:pt-0'>
             <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 md:p-5'>
               <img alt={section1} src={section1} className='w-20' />
               <h6 className='text-center font_medium  text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={2.5} end={13} />+</h6>
               <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Years In Industry</h6>
             </div>

             <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 border-l border-gray-100 md:p-5 md:border-r '>
               <img alt={section2} src={section2} className='w-20' />
               <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={2.5} end={250} />+</h6>
               <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Clients Handling</h6>
             </div>

             <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 mt-4 border-r border-gray-100 md:mt-0 md:p-5 '>
               <img alt={section3} src={section3} className='w-20' />
               <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={4} end={3000} />+</h6>
               <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Man Power Exist</h6>
             </div>

             <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 mt-4 border-gray-100 md:mt-0 md:p-5'>
               <img alt={section4} src={section4} className='w-20' />
               <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={5} separator="," end={50} />+</h6>
               <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Pan India Operations in Cities</h6>
             </div>
          </div>

        </div>

        <div className="px-6 py-16 text-center bg-white md:px-[10%]">
  <h1 className="font_thicker text-[28px] md:text-[42px] 2xl:text-[50px] text-black">
    Smart Facility Management That Powers Your Business
  </h1>

  <p className="max-w-4xl mx-auto mt-5 text-[15px] md:text-[18px] 2xl:text-[21px] font_normal text-gray-600 leading-relaxed">
    We deliver reliable manpower-driven facility solutions that enhance efficiency,
    ensure compliance, and support your growth across India.
  </p>

  <div className="flex flex-col items-center justify-center gap-4 mt-8 sm:flex-row">
    <Link
      to="/contact-us"
      className="px-8 py-3 text-white transition-all duration-300 rounded-full bg-[#418eaa] hover:bg-[#32758d]"
    >
      Get a Quote
    </Link>

    <Link
      to="/Contact"
      className="px-8 py-3 border rounded-full border-[#418eaa] text-[#418eaa] transition-all duration-300 hover:bg-[#418eaa] hover:text-white"
    >
      Contact Us
    </Link>
  </div>
</div>


<div className="relative overflow-hidden px-6 py-14 bg-gradient-to-br from-[#f4fbfd] via-white to-[#eef8fb] md:px-[10%]">
  {/* Background Design */}
  <div className="absolute top-[-80px] right-[-80px] w-[260px] h-[260px] bg-[#027d9b]/10 rounded-full blur-3xl"></div>
  <div className="absolute bottom-[-100px] left-[-80px] w-[280px] h-[280px] bg-[#e58c3d]/10 rounded-full blur-3xl"></div>

  <div className="relative max-w-6xl mx-auto">
    <div data-aos="fade-up" className="text-center">
      <span className="inline-block px-5 py-2 text-[12px] 2xl:text-[14px] font_thicker tracking-wide uppercase rounded-full bg-[#027d9b]/10 text-[#027d9b]">
        Why Choose Fidelitus
      </span>

      <h6 className="mt-5 font_thicker text-[27px] md:text-[38px] 2xl:text-[46px] text-slate-900 leading-tight">
        Why Businesses Trust Fidelitus FMS
      </h6>

      <p className="max-w-3xl mx-auto mt-4 text-[14.5px] md:text-[17px] 2xl:text-[20px] font_normal text-gray-600 leading-relaxed">
        We don’t just manage facilities—we optimize operations and elevate workplace performance.
      </p>
    </div>

    <div className="grid gap-5 mt-11 md:grid-cols-4">
      {[
        {
          no: "01",
          title: "PAN India Presence",
          text: "Seamless service delivery across multiple locations with consistent quality.",
        },
        {
          no: "02",
          title: "Trained & Verified Workforce",
          text: "Skilled manpower ensuring professionalism, safety, and efficiency.",
        },
        {
          no: "03",
          title: "Operational Excellence",
          text: "Streamlined processes that improve productivity and reduce overheads.",
        },
        {
          no: "04",
          title: "Reliable 24/7 Support",
          text: "Always available to ensure uninterrupted facility operations.",
        },
      ].map((item, i) => (
        <div
          key={i}
          data-aos="fade-up"
          data-aos-delay={i * 120}
          className="group relative overflow-hidden min-h-[210px] p-6 rounded-[26px] bg-white/80 backdrop-blur border border-white shadow-[0_15px_45px_rgba(2,125,155,0.10)] transition-all duration-500 hover:-translate-y-3 hover:shadow-[0_25px_60px_rgba(2,125,155,0.18)]"
        >
          <div className="absolute inset-0 transition-opacity duration-500 opacity-0 bg-gradient-to-br from-[#027d9b] to-[#418eaa] group-hover:opacity-100"></div>

          <div className="relative z-10">
            <span className="text-[42px] 2xl:text-[50px] font_thicker text-[#027d9b]/10 transition-all duration-500 group-hover:text-white/20">
              {item.no}
            </span>

            <h6 className="mt-2 font_thicker text-[17px] 2xl:text-[21px] text-slate-900 leading-snug transition-all duration-500 group-hover:text-white">
              {item.title}
            </h6>

            <p className="mt-3 text-[13.5px] 2xl:text-[16px] font_normal text-gray-600 leading-relaxed transition-all duration-500 group-hover:text-white/90">
              {item.text}
            </p>

            <div className="w-10 h-[3px] mt-5 rounded-full bg-[#e58c3d] transition-all duration-500 group-hover:w-20 group-hover:bg-white"></div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

        <div className='py-20'>

            <h6 data-aos="fade-right"  className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>About</span> Us</h6>
            <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div>
           

           <div  className='w-[90%] md:w-[80%] md:flex justify-between mt-16 mx-auto pb-10'>

            <div data-aos="fade-right" className='md:w-[45%]' >
                <h6 className='border-l-4 border-[#e58c3d] pl-3 mx-auto text-slate-800 font-[700] text-[16px] 2xl:text-[19px] mt-2'>We&apos;re FMS Service Provider</h6>
                <h6 className='pl-4 mx-auto text-slate-800 font-[700] font_thicker text-[26px] 2xl:text-[29px] mt-2'>Our History and evolution as a FMS <span className='text-[#e58c3d]'> Service</span> Provider !. </h6>
                <h6 className='mx-auto break-word font_normal text-[15px] 2xl:text-[18px] mt-2 pl-3.5'>Established in 2013, Fidelitus Facility Management Services has grown into a 3000+ workforce delivering reliable facility management solutions across multiple sectors. With a strong PAN-India presence, we provide high-quality housekeeping, security, technical, and workforce support services. Our commitment to excellence and customer-focused approach continues to drive our growth and trusted reputation nationwide.</h6>

                <h6 onClick={()=>navigator('/about')} className='text-[12px] 2xl:text-[15px] font-[400] hover:bg-gray-200 ml-3 mx-1.5 cursor-pointer mt-5 pl-2  p-[4px] bg-gray-100 w-[100px] '>KNOW MORE</h6>
            </div>
            <div data-aos="fade-up" className='mt-10 md:mt-0 md:w-[45%] relative' >
                 <img alt={about} src={about} />

                 <div className='absolute w-[50%] top-[35%] left-[25%]'>
                   {/* <Typist startDelay={1000}> */}
                   <h6 className='text-center font_thicker text-[13px] 2xl:text-[16px]'>From last</h6>
                   <h6 className='text-center font_thicker text-[30px] 2xl:text-[33px]'>10+ <span className='text-[10px]'>Years</span></h6>
                   <h6 className='text-center font_thicker text-[13px] 2xl:text-[16px]'>Fumigation Service Provider</h6>
                   {/* </Typist> */}
                 </div>
            </div>    

            </div>

        </div>

        {/* <div className='px-[10%] pt-16 border-t border-gray-100'>
            <div className='md:w-[65%]'>
              <h6 className='font_thicker text-[17px] 2xl:text-[20px] border-l-4 border-[#e58c3d] pl-4'>Why we stand Out in Facility Management Service</h6>
              <div data-aos="fade-left" data-aos-delay="300" className='flex items-center justify-center w-full mt-1'>
              <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
              <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
              </div>
            </div>

             <h6 data-aos="fade-left" className='font_normal text-[14.5px] 2xl:text-[17.5px] mt-4'> We excel in facility management due to our dedicated team, comprehensive solutions, and client-centric approach. Our expertise ensures efficient operations, cost-effectiveness, and optimal tenant experiences, setting us apart as leaders in the industry.</h6>

             <div className='grid grid-cols-1 gap-2 my-10 md:grid-cols-5'>
                {stand_out?.map((s,i)=>(
                  <div key={i} data-aos="fade-up" data-aos-delay="300" className='flex flex-col items-center justify-center p-4 border cursor-pointer'>
                        <img alt={s?.img} src={s?.img} className='object-contain w-24 h-20 opacity-80' />
                        <h6 className='font_thicker font-[900]  text-center  text-[13.5px] 2xl:text-[16.5px] mt-1.5'>{s?.name}</h6>
                        <h6 className='font_normal text-[12px] 2xl:text-[15px] text-center '>{s?.val}</h6>
                  </div> 
                ))}
             </div>
          </div> */}

        <div className='py-20 bg-gray-50'>


        <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>Our</span> Services</h6>
            <div className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div>
            <h6 className='text-center w-[80%] md:w-full mx-auto font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>Integrated Facility Management Solutions.</h6>


            <div className='w-[90%] md:w-[80%] mx-auto'>

            <h6 data-aos="fade-left" className='text-[14px] 2xl:text-[17px] text-gray-700 font_normal mt-10 text-center' >Comprehensive services designed to keep your business running smoothly.</h6>
           
            <div className='grid grid-cols-1 gap-4 mt-10 md:grid-cols-3'>
               {services?.map((s,i)=>(
                <div key={i} data-aos="fade-up" className='flex items-center justify-center p-3 bg-white rounded-md shadow-md cursor-pointer'>
                   <img alt={s?.img} className='w-[90px]  h-[90px]' src={s?.img} /> 
                   <div className='pl-3'>
                   <h6 className='mt-2 2xl:text-[18px] font_thicker'>{s?.name}</h6>
                   <h6 className='mt-1 text-gray-600 font_normal opacity-70 text-[14px] 2xl:text-[17px]'>{s?.val}</h6>
                   </div>
                </div>   
               ))}
            </div> 

            </div>
        </div>
        <div className="flex justify-center mt-10">
  <Link
    to="/services"
    className="relative inline-flex items-center justify-center px-9 py-3 overflow-hidden text-white transition-all duration-300 rounded-full group bg-[#027d9b] hover:bg-[#026b84] hover:scale-105 shadow-lg shadow-[#027d9b]/20"
  >
    <span className="absolute inset-0 w-full h-full transition-transform duration-700 -translate-x-full bg-white/20 group-hover:translate-x-full"></span>
    <span className="relative z-10">Explore All Services</span>
  </Link>
</div>

        <div className='py-10'>
            <h6 className='text-center font_medium text-[21px] 2xl:text-[24px] pt-10'> Trusted by <span className='text-[#4190ac]'>Leading Businesses</span> across India</h6>
            <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center font_normal justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center font_normal justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div>
            <h6 className='text-center font_normal mt-2 text-black w-[90%] md:w-[70%] mx-auto text-[14.5px] 2xl:text-[17.5px]'>Our commitment to quality and consistency has earned the trust of clients nationwide.</h6>
            <div className='w-[80vw]  mx-auto py-16'> 
            <Slider {...settings}>
                {clients?.map((c)=>(
                <div key={c?.id} className='flex items-center justify-center focus:outline-none focus:ring-0'>
                  <img alt={c?.img} className='focus:outline-none h-18 md:h-18 object-stretch focus:ring-0' src={c?.img}  />
                </div>
                ))}
            </Slider>
            </div> 

        </div>



        <div className='py-10 bg-gray-50'>
            <h6 className='text-center font_medium text-[21px] 2xl:text-[24px] pt-10'>Our Client <span className='text-[#4190ac]'> Testimonials</span></h6>
            <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div>
            <h6 className='text-center font_normal mt-2 text-[14.5px] 2xl:text-[17.5px] mx-10'>Trusted by our clients for delivering reliable, efficient, and high-quality facility management services.</h6>

            <div className='w-[80vw]  mx-auto py-10'> 
            <Slider {...settings1}>
                {testimonials?.map((c)=>(
                <div data-aos="fade-up" key={c?.id} className='border-2 border-[#fafafa] rounded-md p-2 max-w-[95%]  mr-[2%] bg-white flex items-center justify-center focus:outline-none focus:ring-0'>
                  <img alt={c?.img} className={`w-[100px] h-14 rounded object-contain flex items-start justify-start  focus:outline-none focus:ring-0`} src={c?.img}  />
                  <div className='ml-3'>
                    <h6 className='text-[14px] 2xl:text-[17px] font-[700] font_medium'>{c?.name}</h6>
                    <h6 className='text-[12.5px] 2xl:text-[15.5px] font_normal text-slate-700 mt-1 '>{c?.testimonial}</h6>
                  </div>
                </div>
                ))}
            </Slider>
            </div> 


        </div>  
        <div className="relative mx-6 my-14 overflow-hidden rounded-[28px] bg-gradient-to-r from-[#027d9b] via-[#418eaa] to-[#6bb5c9] px-6 py-12 text-center shadow-xl md:mx-[10%]">
  <div className="absolute top-[-60px] right-[-60px] w-[180px] h-[180px] rounded-full bg-white/20 blur-2xl"></div>
  <div className="absolute bottom-[-70px] left-[-70px] w-[220px] h-[220px] rounded-full bg-[#e58c3d]/20 blur-2xl"></div>

  <div className="relative z-10">
    <h6 className="font_thicker text-[24px] md:text-[36px] 2xl:text-[44px] text-white leading-tight">
      Let Fidelitus Handle Your Facilities While You Focus on Growth
    </h6>

    <Link
      to="/contact-us"
      className="inline-flex items-center justify-center px-8 py-3 mt-7 overflow-hidden text-[#027d9b] transition-all duration-300 bg-white rounded-full font_thicker hover:scale-105 hover:shadow-lg"
    >
      Partner With Us
    </Link>
  </div>
</div> 

        <div className='py-20'>


        <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>Our reach spanning </span> across sectors </h6>
            <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div>
            <h6 className='text-center  font_normal mt-2 text-[14.5px] 2xl:text-[15.5px] mx-10'>As one of the leading companies as Fidelitus IFMS service provider, we have a wide reach across sectors including, healthcare, corporate, educational institutions, and more.</h6>


            <div className='w-[80%] mx-auto'>

           
            <div className='grid grid-cols-3 gap-2 mt-10 md:grid-cols-8'>
               {industries?.map((s,i)=>(
                <div key={i} data-aos="fade-up" className='grid items-center justify-center w-full'>
                  <div>
                   <img alt={s?.img} className={`${(s?.name === 'Pharmaceutical' || s?.name === 'Bank') && 'opacity-80'} object-contain  h-[65px]`} src={s?.img} /> 
                   </div>
                   <h6 className='mt-2 text-[13px] 2xl:text-[16px] text-center mb-4 font_thicker'>{s?.name}</h6>
                </div>   
               ))}
            </div> 

            </div>
        </div>  

        <div className='py-20 bg-gray-50'>
            <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>Frequently Asked  <span className='text-[#4190ac]'>Questions </span> </h6>

            <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div>

            <h6 className='text-center  font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>The question that peoply ask us frequently and we response to them.</h6>


            <div className='w-[80%] mx-auto py-16'>
              <h6 data-aos-delay="100" data-aos="fade-right" onClick={()=>setstep(1)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> What are the benefits of effective facilities management?</h6>
              <h6 className={`transition-all pl-6 duration-300 ${step === 1 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>Clean and hygienic premises, proper functioning of assets, and effective resource utilisation leading to reduction of repair and maintenance overheads, and happy employees are some of the benefits of effective facility management.</h6>

              <h6 data-aos-delay="200" data-aos="fade-right" onClick={()=>setstep(2)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> Why is a facilities management company vital for your business?</h6>
              <h6 className={`transition-all pl-6 duration-300 ${step === 2 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>A facility management company takes a load off your non-core activities, allowing you to focus on your core business area, delivering cutting-edge services and products to your clients. Expertise in facilities management enables better planning, and preventive measures are undertaken to improve the longevity of the asset and infrastructure, thereby reducing unwanted overheads and saving time.</h6>

              <h6 data-aos-delay="300" data-aos="fade-right" onClick={()=>setstep(3)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> what should I look for in a facilities management company?</h6>
              <h6 className={`transition-all pl-6 duration-300 ${step === 3 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>While selecting a facility management partner, evaluate how do they score on the parameters of agility, technology, and scalability. In addition to that, learn how the company weather challenges and streamlines processes, the certifications received, and if they have the expertise to guide through unexpected challenges.</h6>


            </div>
        </div>  


        <div className='py-20'>
            <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>We are the certified  <span className='text-[#4190ac]'>IFMS </span> service provider</h6>

            <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div>

            <h6 className='text-center mx-10 font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>We are cerified as ISO to provide all the services that has been mentioned above.</h6>

            

            <div className='grid mx-[10%] gap-2 grid-cols-2 md:grid-cols-9 mt-10'>
            {/* <Slider {...settings2}> */}
                <img src={cert1} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
                <img src={cert2} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
                <img src={cert3} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
                <img src={cert4} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
                <img src={cert5} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
                <img src={cert6} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
                <img src={cert7} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
                <img src={cert8} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
                <img src={cert9} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
            {/* </Slider> */}
            </div>
        </div>  


    </div>
  )
}

export default Home









//====>> Old backup 

// import React,{useState,useRef,useEffect} from 'react';
// import {BsArrowLeftCircle,BsArrowRightCircle} from 'react-icons/bs';
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';
// import CountUp from 'react-countup';

// // clients 

// import client1 from '../images/clients/1.png';
// import client2 from '../images/clients/2.png';
// import client3 from '../images/clients/3.png';
// import client4 from '../images/clients/4.png';
// import client5 from '../images/clients/5.png';
// import client6 from '../images/clients/6.png';
// import client7 from '../images/clients/7.png';
// import client8 from '../images/clients/8.png';
// import client9 from '../images/clients/9.png';
// import client10 from '../images/clients/10.png';
// import client11 from '../images/clients/11.png';
// import client12 from '../images/clients/12.png';
// import client13 from '../images/clients/13.png';
// import client14 from '../images/clients/14.png';
// import client15 from '../images/clients/15.png';
// import client16 from '../images/clients/16.png';
// import client17 from '../images/clients/17.png';
// import client18 from '../images/clients/18.png';
// import client19 from '../images/clients/19.png';
// import client20 from '../images/clients/20.png';
// import client21 from '../images/clients/21.png';
// import client22 from '../images/clients/22.png';
// import client23 from '../images/clients/23.png';
// import client24 from '../images/clients/24.png';
// import client25 from '../images/clients/25.png';
// import client26 from '../images/clients/26.png';
// import client27 from '../images/clients/27.png';
// import client28 from '../images/clients/28.png';
// import client29 from '../images/clients/29.png';
// import client30 from '../images/clients/30.png';
// import client31 from '../images/clients/31.png';
// import client32 from '../images/clients/32.png';
// import client33 from '../images/clients/33.png';
// import client34 from '../images/clients/34.png';
// import client35 from '../images/clients/35.png';
// import client36 from '../images/clients/36.png';
// import client37 from '../images/clients/37.png';
// import client38 from '../images/clients/38.png';
// import client39 from '../images/clients/39.png';
// import client40 from '../images/clients/40.png';
// import client41 from '../images/clients/41.png';
// import client42 from '../images/clients/42.png';
// import client43 from '../images/clients/43.png';
// import client44 from '../images/clients/44.png';
// import client45 from '../images/clients/45.png';
// import client46 from '../images/clients/46.png';
// import client47 from '../images/clients/47.png';
// import client48 from '../images/clients/48.png';
// import client49 from '../images/clients/49.png';
// import client50 from '../images/clients/50.png';
// import client51 from '../images/clients/51.png';
// import client52 from '../images/clients/52.png';

// import Slider from "react-slick";

// // places 

// import health from '../images/industry/Healthcare.png';
// import education from '../images/industry/college.png';
// import industry from '../images/industry/industrial.png';
// import corperate from '../images/industry/corperate.png';
// import retial from '../images/industry/industrial.png';
// import pharmaceutical from '../images/industry/observation.png';
// import bank from '../images/industry/bank.png';
// import commercial from '../images/industry/building.png';

// import banner1 from '../images/banner/banner1.jpeg'


// // stand out

// import stand1 from '../images/stand_out/service_offering.png'
// import stand2 from '../images/stand_out/experienced_professionals.png'
// import stand3 from '../images/stand_out/hassle_execution.png'
// import stand4 from '../images/stand_out/diverse_offering.png'
// import stand5 from '../images/stand_out/client_testimonials.png'


// // services

// import ss from '../images/services/ss.png';
// import hs from '../images/services/hs.png';
// import se from '../images/services/se.png';

// //sections

// import section1 from '../images/section/infrastructure.png'
// import section2 from '../images/section/public-relation.png'
// import section3 from '../images/section/places.png'
// import section4 from '../images/section/like.png'


// //certificated 

// import cert1 from '../images/certificate/9001.jpg'
// import cert2 from '../images/certificate/14001.jpg'
// import cert3 from '../images/certificate/27001.jpg'
// import cert4 from '../images/certificate/45001.jpg'
// import cert5 from '../images/certificate/50001.jpg'
// import cert6 from '../images/certificate/CLRA.jpg'
// import cert7 from '../images/certificate/FCPLPsara.jpg'
// import cert8 from '../images/certificate/LICENSE CERTIFICATE.jpg'
// import cert9 from '../images/certificate/Sanitary.jpg'
// // import cert1 from '../../images/certificate/9001.pdf'
// // import cert1 from '../../images/certificate/9001.pdf'

// import about from '../images/fidelitus.jpeg'


// import {IoIosArrowBack,IoIosArrowForward} from 'react-icons/io';
// import {FiPlusCircle} from 'react-icons/fi';

// import Typist from 'react-typist';
// import { useNavigate } from 'react-router-dom';

// import videoPlay from '../images/video.mp4'
// import toast from 'react-hot-toast';

// function Home() {
 
//       const videoRef = useRef(null);

//       const navigator = useNavigate() 
//       const images = [banner1]

//       const [step,setstep] = useState(0)

//       useEffect(() => {
//         const video = videoRef.current;
//         if (video) {
//           // Attempt to play the video
//           video.play().catch(error => {
//            toast.error("Oops we couldn't play the video for you!")
  
//             // Handle error (e.g., show a play button)
//             console.log('Autoplay prevented. Showing play button.');
//           });
//         }
//     }, []);
  
//       const services = [
//         {
//           img:ss,
//           name:'Soft Service',
//           val:'We offer a wide range of facility services to suit your needs'
//         },
//         {
//           img:hs,
//           name:'Hard Services',
//           val:'We create an impact with our smart engineering services'
//         },
//         {
//           img:se,
//           name:'Security Services',
//           val:'With our trained security guard, the security service will be easy'
//         },
//       ]

//       const testimonials = [
//         {
//           id:1,
//           name:"Melvin D'Souza",
//           company:'MAVERIK',
//           testimonial:'We are associated with Fidelitus Corp Integrated Facility Services for last one year and we are very happy to recommend you to any other companies and very happy with your all services like security, housekeeping, and other highlight services with the team.',
//           img:client52,
//           date:'12 May 2022'
//         },
//         {
//           id:3,
//           name:'Sundari Rajan',
//           company:'Colive',
//           testimonial:'I have mention that over the last two years which probably are of the worst time of us Fidelitus FMS stood by us during the covid time shown a lot of solidarity and support will working with the team and also been very proactive in the team of approach support the great credit goes to Ms. Shubhalaxmi and entire team who is work very closely with our team to makesure of successful partnership, we are look for long association with them. Great work Fidelitus.',
//           img:client39,
//           date:'14 Jan 2023'
//         },
//         {
//           id:2,
//           name:'Raghav Suvarna',
//           company:'Softtek India pvt ltd',
//           testimonial:'We are working with Fidelitus Facility team since from 5 years. They are providing discipled service with great team work in our premises. They have very dedicated and competing team. We are happy to associate with Fidelitus Facility Team.',
//           img:client1,
//           date:'10 Jan 2022'
    
//         },
//       ]

//       const stand_out = [
//         {
//           img:stand1,
//           name:'Customer-Centric Approach',
//           val:'Your needs are at the heart of our solutions, ensuring personalized and effective services.'
//         },
//         {
//           img:stand2,
//           name:'Experienced Professionals',
//           val:'Our team of skilled experts guarantees unmatched proficiency in facility management.'
//         },
//         {
//           img:stand3,
//           name:'Hassle-Free Execution',
//           val:'We take full responsibility, ensuring smooth operations and minimal disruptions.'
//         },
//         {
//           img:stand4,
//           name:'Diverse Service Offerings',
//           val:'From security to landscaping, we offer a comprehensive range of facility management solutions.'
//         },
//         {
//           img:stand5,
//           name:'Client Testimonials',
//           val:'Our satisfied clients speak volumes about the quality of our services and dedication.'
//         },
//       ]

//       const industries = [
//          {
//             id:1,
//             img:health,
//             name:'Healthcare'
//          },
//          {
//           id:2,
//           img:education,
//           name:'Institutional'
//          },
//          {
//           id:3,
//           img:industry,
//           name:'Industrial'
//          },
//          {
//           id:4,
//           img:corperate,
//           name:'Corporate'
//          },
//          {
//           id:5,
//           img:retial,
//           name:'Retail'
//          },
//          {
//           id:6,
//           img:commercial,
//           name:'Commercial'
//          },
//         //  {
//         //   id:6,
//         //   img:'',
//         //   name:'Resedential'
//         //  },
//          {
//           id:7,
//           img:pharmaceutical,
//           name:'Pharmaceutical'
//          },
//          {
//           id:8,
//           img:bank,
//           name:'Bank'
//          },
//         //  {
//         //   id:9,
//         //   img:mall,
//         //   name:'Mall'
//         //  },

//       ]

//       const settings = {
//         dots: false,
//         arrows: true,
//         infinite: true,
//         speed: 100,
//         slidesToShow: 6,
//         slidesToScroll: 4,
//         initialSlide: 0,
//         centerMode: true,
//         cssEase: "linear",
//         autoplaySpeed: 2000,
//         centerPadding: '0px',
//         autoPlay:true,
//         prevArrow:<SampleNextArrow />,
//         nextArrow:<SamplePrevArrow />,
//         responsive: [
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               autoPlay:true
             
//             }
//           },
//           {
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               initialSlide: 3,
//               autoPlay:true
    
//             }
//           },
//           {
//             breakpoint: 480,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               initialSlide: 3,
//               autoPlay:true
//             }
//           }
//         ]
//       };
    
//       const settings1 = {
//         dots: false,
//         arrows: true,
//         infinite: true,
//         speed: 100,
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         initialSlide: 0,
//         centerMode: true,
//         cssEase: "linear",
//         autoplaySpeed: 2000,
//         centerPadding: '0px',
//         autoPlay:true,
//         prevArrow:<SampleNextArrow />,
//         nextArrow:<SamplePrevArrow />,
//         responsive: [
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               autoPlay:true
             
//             }
//           },
//           {
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 2,
//               initialSlide: 2,
//               autoPlay:true
    
//             }
//           },
//           {
//             breakpoint: 480,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1,
//               initialSlide: 1,
//               autoPlay:true
//             }
//           }
//         ]
//       };

     
//       function SampleNextArrow(props) {
//         const { className, style, onClick } = props;
//         return (
//         <BsArrowLeftCircle 
//         className={`${className} -mt-0  md:-mt-12 `}
//         style={{ ...style, display: "block",color:'#ddd',}}
//         onClick={onClick} />
//         );
//       }
      
//       function SamplePrevArrow(props) {
//         const { className, style, onClick } = props;
//         return (
//           <BsArrowRightCircle 
//               className={`${className} -mt-0 md:-mt-12 `}
//               style={{ ...style, display: "block",color:'#ddd',}}
//               onClick={onClick} />
//         );
//       }
  
//       const clients = [ 
//           {
//             id:1,
//             img:client1
//           },
//           {
//             id:2,
//             img:client2      
//           },
//           {
//             id:3,
//             img:client3
//           },
//           {
//             id:4,
//             img:client4
//           },
//           {
//             id:5,
//             img:client5
//           },
//           {
//             id:6,
//             img:client6
//           },
//           {
//             id:7,
//             img:client7
//           },
//           {
//             id:8,
//             img:client8
//           },
//           {
//             id:9,
//             img:client9
//           },
//           {
//             id:10,
//             img:client10
//           },
//           {
//             id:11,
//             img:client11
//           },
//           {
//             id:12,
//             img:client12
//           },
//           {
//             id:13,
//             img:client13
//           },
//           {
//             id:14,
//             img:client14
//           },
//           {
//             id:15,
//             img:client15
//           },
//           {
//             id:16,
//             img:client16
//           },
//           {
//               id:17,
//               img:client17
//             },
//             {
//               id:18,
//               img:client18     
//             },
//             {
//               id:19,
//               img:client19
//             },
//             {
//               id:20,
//               img:client20
//             },
//             {
//               id:21,
//               img:client21
//             },
//             {
//               id:22,
//               img:client22
//             },
//             {
//               id:23,
//               img:client23
//             },
//             {
//               id:24,
//               img:client24
//             },
//             {
//               id:25,
//               img:client25
//             },
//             {
//               id:26,
//               img:client26
//             },
//             {
//               id:27,
//               img:client27
//             },
//             {
//               id:28,
//               img:client28
//             },
//             {
//               id:29,
//               img:client29
//             },
//             {
//               id:30,
//               img:client30
//             },
//             {
//               id:31,
//               img:client31
//             },
//             {
//               id:32,
//               img:client32
//             },
//             {
//               id:33,
//               img:client33
//             },
//             {
//               id:34,
//               img:client34     
//             },
//             {
//               id:35,
//               img:client35
//             },
//             {
//               id:36,
//               img:client36
//             },
//             {
//               id:37,
//               img:client37
//             },
//             {
//               id:38,
//               img:client38
//             },
//             {
//               id:39,
//               img:client39
//             },
//             {
//               id:40,
//               img:client40
//             },
//             {
//               id:41,
//               img:client41
//             },
//             {
//               id:42,
//               img:client42
//             },
//             {
//               id:43,
//               img:client43
//             },
//             {
//               id:44,
//               img:client44
//             },
//             {
//               id:45,
//               img:client45
//             },
//             {
//               id:46,
//               img:client46
//             },
//             {
//               id:47,
//               img:client47
//             },
//             {
//               id:48,
//               img:client48
//             },
//             {
//               id:49,
//               img:client49
//             },
//             {
//               id:50,
//               img:client50
//             },
//             {
//               id:51,
//               img:client51
//             }
//       ]

//   return (
//     <div className='overflow-hidden max-w-sceen'>
//         {/* <Carousel 
//             centerMode={true} 
//             autoPlay={true} 
//             showStatus={false}
//             showThumbs={false}
//             showArrows={true}
//             swipeable={true}
//             autoFocus={true}
//             centerSlidePercentage={100}
//             showIndicators={false}
//             className=''
//             renderArrowPrev={(clickHandler, hasPrev) => {
//               return (
//                 <div
//                   className={`${hasPrev ? "opacity-100" : "opacity-20"} absolute right-[35px] border-r-2 border-gray-100 bottom-0 bg-white  flex justify-center items-center p-2  cursor-pointer z-20`}
//                   onClick={clickHandler}
//                 >
//                   <IoIosArrowBack size={20} className="text-black" />
//                 </div>
//               );
//             }}
//             renderArrowNext={(clickHandler, hasPrev) => {
//               return (
//                 <div
//                   className={`${hasPrev ? "opacity-100" : "opacity-20"} absolute right-0 bottom-0 bg-white  flex justify-center items-center p-2  cursor-pointer z-20`}
//                   onClick={clickHandler}
//                 >
//                   <IoIosArrowForward size={20} className="text-black" />
//                 </div>
//               );
//             }}
          
//           >
//               {images?.map((c,i)=>(
//                   <div key={i} className='text-center relative relative w-[100%] mx-auto focus:outline-none focus:ring-0'>
//                      <img alt={c} src={c}  className='w-full h-[35vh] md:h-[92.4vh] object-cover md:object-cover focus:outline-none focus:ring-0 '/>

//                      <div data-aos="fade-left" className='border-l-4 border-[#4190ac]  w-[75%]  md:w-[25%] pl-4 absolute top-[10%] right-[5%]'> 
//                           <h1 className='text-[20px] text-left font_thicker text-[#e58c3d]'>Fidelitus IFMS  </h1>
//                           <h6 className='text-left font_thick font-bold text-[15px] text-white'>A Global Integrated Facility Managment Services Provider</h6>
//                           <h6 className='text-left font_normal text-[13px] text-white'>As a recoginized IFMS We are ready to add care to your space</h6>
//                      </div>
//                   </div>    
//                ))}



             

//         </Carousel> */}

//         <video  ref={videoRef} id="video"  width="100%"  controls={false}  autoPlay playsInline loop muted className="w-full md:h-[90vh] object-cover">
//              <source src={videoPlay} type="video/mp4"/> 
//               {/* <source src={videoPlay1} type="video/mp4"/> */}
//             </video>


//         <div className='bg-[#418eaa]  py-10'>
//         <div className=' md:border-none grid grid-cols-2 md:grid-cols-4  ml-0 md:px-[10%]   md:mt-0   md:pt-0'>
//              <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 md:p-5'>
//                <img alt={section1} src={section1} className='w-20' />
//                <h6 className='text-center font_medium  text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={2.5} end={13} />+</h6>
//                <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Years In Industry</h6>
//              </div>

//              <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 border-l border-gray-100 md:p-5 md:border-r '>
//                <img alt={section2} src={section2} className='w-20' />
//                <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={2.5} end={250} />+</h6>
//                <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Clients Handling</h6>
//              </div>

//              <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 mt-4 border-r border-gray-100 md:mt-0 md:p-5 '>
//                <img alt={section3} src={section3} className='w-20' />
//                <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={4} end={3000} />+</h6>
//                <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Man Power Exist</h6>
//              </div>

//              <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 mt-4 border-gray-100 md:mt-0 md:p-5'>
//                <img alt={section4} src={section4} className='w-20' />
//                <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={5} separator="," end={50} />+</h6>
//                <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Pan India Operations in Cities</h6>
//              </div>
//           </div>

//         </div>


//         <div className='py-20'>

//             <h6 data-aos="fade-right"  className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>About</span> Us</h6>
//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
           

//            <div  className='w-[90%] md:w-[80%] md:flex justify-between mt-16 mx-auto pb-10'>

//             <div data-aos="fade-right" className='md:w-[45%]' >
//                 <h6 className='border-l-4 border-[#e58c3d] pl-3 mx-auto text-slate-800 font-[700] text-[16px] 2xl:text-[19px] mt-2'>We&apos;re FMS Service Provider</h6>
//                 <h6 className='pl-4 mx-auto text-slate-800 font-[700] font_thicker text-[26px] 2xl:text-[29px] mt-2'>Our History and evolution as a FMS <span className='text-[#e58c3d]'> Service</span> Provider !. </h6>
//                 <h6 className='mx-auto break-word font_normal text-[15px] 2xl:text-[18px] mt-2 pl-3.5'>Established in 2013, Fidelitus Facility Management Services has grown into a 3000+ workforce delivering reliable facility management solutions across multiple sectors. With a strong PAN-India presence, we provide high-quality housekeeping, security, technical, and workforce support services. Our commitment to excellence and customer-focused approach continues to drive our growth and trusted reputation nationwide.</h6>

//                 <h6 onClick={()=>navigator('/about')} className='text-[12px] 2xl:text-[15px] font-[400] hover:bg-gray-200 ml-3 mx-1.5 cursor-pointer mt-5 pl-2  p-[4px] bg-gray-100 w-[100px] '>KNOW MORE</h6>
//             </div>
//             <div data-aos="fade-up" className='mt-10 md:mt-0 md:w-[45%] relative' >
//                  <img alt={about} src={about} />

//                  <div className='absolute w-[50%] top-[35%] left-[25%]'>
//                    {/* <Typist startDelay={1000}> */}
//                    <h6 className='text-center font_thicker text-[13px] 2xl:text-[16px]'>From last</h6>
//                    <h6 className='text-center font_thicker text-[30px] 2xl:text-[33px]'>10+ <span className='text-[10px]'>Years</span></h6>
//                    <h6 className='text-center font_thicker text-[13px] 2xl:text-[16px]'>Fumigation Service Provider</h6>
//                    {/* </Typist> */}
//                  </div>
//             </div>    

//             </div>

//         </div>

//         {/* <div className='px-[10%] pt-16 border-t border-gray-100'>
//             <div className='md:w-[65%]'>
//               <h6 className='font_thicker text-[17px] 2xl:text-[20px] border-l-4 border-[#e58c3d] pl-4'>Why we stand Out in Facility Management Service</h6>
//               <div data-aos="fade-left" data-aos-delay="300" className='flex items-center justify-center w-full mt-1'>
//               <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//               <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//               </div>
//             </div>

//              <h6 data-aos="fade-left" className='font_normal text-[14.5px] 2xl:text-[17.5px] mt-4'> We excel in facility management due to our dedicated team, comprehensive solutions, and client-centric approach. Our expertise ensures efficient operations, cost-effectiveness, and optimal tenant experiences, setting us apart as leaders in the industry.</h6>

//              <div className='grid grid-cols-1 gap-2 my-10 md:grid-cols-5'>
//                 {stand_out?.map((s,i)=>(
//                   <div key={i} data-aos="fade-up" data-aos-delay="300" className='flex flex-col items-center justify-center p-4 border cursor-pointer'>
//                         <img alt={s?.img} src={s?.img} className='object-contain w-24 h-20 opacity-80' />
//                         <h6 className='font_thicker font-[900]  text-center  text-[13.5px] 2xl:text-[16.5px] mt-1.5'>{s?.name}</h6>
//                         <h6 className='font_normal text-[12px] 2xl:text-[15px] text-center '>{s?.val}</h6>
//                   </div> 
//                 ))}
//              </div>
//           </div> */}

//         <div className='py-20 bg-gray-50'>


//         <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>Our</span> Services</h6>
//             <div className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
//             <h6 className='text-center w-[80%] md:w-full mx-auto font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>The main sector we focus to provided 100% satisfaction to our clients.</h6>


//             <div className='w-[90%] md:w-[80%] mx-auto'>

//             <h6 data-aos="fade-left" className='text-[14px] 2xl:text-[17px] text-gray-700 font_normal mt-10'>At Fidelitus Facility Management Services, we deliver reliable, efficient, and customized facility solutions designed to keep your business running seamlessly. From housekeeping and security to technical maintenance and support services, our expert team ensures high standards of safety, cleanliness, and operational excellence.</h6>
           
//             <div className='grid grid-cols-1 gap-4 mt-10 md:grid-cols-3'>
//                {services?.map((s,i)=>(
//                 <div key={i} data-aos="fade-up" className='flex items-center justify-center p-3 bg-white rounded-md shadow-md cursor-pointer'>
//                    <img alt={s?.img} className='w-[90px]  h-[90px]' src={s?.img} /> 
//                    <div className='pl-3'>
//                    <h6 className='mt-2 2xl:text-[18px] font_thicker'>{s?.name}</h6>
//                    <h6 className='mt-1 text-gray-600 font_normal opacity-70 text-[14px] 2xl:text-[17px]'>{s?.val}</h6>
//                    </div>
//                 </div>   
//                ))}
//             </div> 

//             </div>
//         </div>

//         <div className='py-10'>
//             <h6 className='text-center font_medium text-[21px] 2xl:text-[24px] pt-10'>A Trusted clients of<span className='text-[#4190ac]'> Fidelitus FMS</span> Services</h6>
//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center font_normal justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center font_normal justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
//             <h6 className='text-center font_normal mt-2 text-black w-[90%] md:w-[70%] mx-auto text-[14.5px] 2xl:text-[17.5px]'>We provide businesses across the globe with the means to achieve their company expansion goals</h6>
 
//             <div className='w-[80vw]  mx-auto py-16'> 
//             <Slider {...settings}>
//                 {clients?.map((c)=>(
//                 <div key={c?.id} className='flex items-center justify-center focus:outline-none focus:ring-0'>
//                   <img alt={c?.img} className='focus:outline-none h-18 md:h-18 object-stretch focus:ring-0' src={c?.img}  />
//                 </div>
//                 ))}
//             </Slider>
//             </div> 

//         </div>

//         <div className='py-10 bg-gray-50'>
//             <h6 className='text-center font_medium text-[21px] 2xl:text-[24px] pt-10'>Our Client <span className='text-[#4190ac]'> Testimonials</span></h6>
//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
//             <h6 className='text-center font_normal mt-2 text-[14.5px] 2xl:text-[17.5px] mx-10'>Trusted by our clients for delivering reliable, efficient, and high-quality facility management services.</h6>

//             <div className='w-[80vw]  mx-auto py-10'> 
//             <Slider {...settings1}>
//                 {testimonials?.map((c)=>(
//                 <div data-aos="fade-up" key={c?.id} className='border-2 border-[#fafafa] rounded-md p-2 max-w-[95%]  mr-[2%] bg-white flex items-center justify-center focus:outline-none focus:ring-0'>
//                   <img alt={c?.img} className={`w-[100px] h-14 rounded object-contain flex items-start justify-start  focus:outline-none focus:ring-0`} src={c?.img}  />
//                   <div className='ml-3'>
//                     <h6 className='text-[14px] 2xl:text-[17px] font-[700] font_medium'>{c?.name}</h6>
//                     <h6 className='text-[12.5px] 2xl:text-[15.5px] font_normal text-slate-700 mt-1 '>{c?.testimonial}</h6>
//                   </div>
//                 </div>
//                 ))}
//             </Slider>
//             </div> 


//         </div>  

//         <div className='py-20'>


//         <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>Our reach spanning </span> across sectors </h6>
//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
//             <h6 className='text-center  font_normal mt-2 text-[14.5px] 2xl:text-[15.5px] mx-10'>As one of the leading companies as Fidelitus IFMS service provider, we have a wide reach across sectors including, healthcare, corporate, educational institutions, and more.</h6>


//             <div className='w-[80%] mx-auto'>

           
//             <div className='grid grid-cols-3 gap-2 mt-10 md:grid-cols-8'>
//                {industries?.map((s,i)=>(
//                 <div key={i} data-aos="fade-up" className='grid items-center justify-center w-full'>
//                   <div>
//                    <img alt={s?.img} className={`${(s?.name === 'Pharmaceutical' || s?.name === 'Bank') && 'opacity-80'} object-contain  h-[65px]`} src={s?.img} /> 
//                    </div>
//                    <h6 className='mt-2 text-[13px] 2xl:text-[16px] text-center mb-4 font_thicker'>{s?.name}</h6>
//                 </div>   
//                ))}
//             </div> 

//             </div>
//         </div>  

//         <div className='py-20 bg-gray-50'>
//             <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>Frequently Asked  <span className='text-[#4190ac]'>Questions </span> </h6>

//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>

//             <h6 className='text-center  font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>The question that peoply ask us frequently and we response to them.</h6>


//             <div className='w-[80%] mx-auto py-16'>
//               <h6 data-aos-delay="100" data-aos="fade-right" onClick={()=>setstep(1)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> What are the benefits of effective facilities management?</h6>
//               <h6 className={`transition-all pl-6 duration-300 ${step === 1 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>Clean and hygienic premises, proper functioning of assets, and effective resource utilisation leading to reduction of repair and maintenance overheads, and happy employees are some of the benefits of effective facility management.</h6>

//               <h6 data-aos-delay="200" data-aos="fade-right" onClick={()=>setstep(2)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> Why is a facilities management company vital for your business?</h6>
//               <h6 className={`transition-all pl-6 duration-300 ${step === 2 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>A facility management company takes a load off your non-core activities, allowing you to focus on your core business area, delivering cutting-edge services and products to your clients. Expertise in facilities management enables better planning, and preventive measures are undertaken to improve the longevity of the asset and infrastructure, thereby reducing unwanted overheads and saving time.</h6>

//               <h6 data-aos-delay="300" data-aos="fade-right" onClick={()=>setstep(3)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> what should I look for in a facilities management company?</h6>
//               <h6 className={`transition-all pl-6 duration-300 ${step === 3 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>While selecting a facility management partner, evaluate how do they score on the parameters of agility, technology, and scalability. In addition to that, learn how the company weather challenges and streamlines processes, the certifications received, and if they have the expertise to guide through unexpected challenges.</h6>


//             </div>
//         </div>  


//         <div className='py-20'>
//             <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>We are the certified  <span className='text-[#4190ac]'>IFMS </span> service provider</h6>

//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>

//             <h6 className='text-center mx-10 font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>We are cerified as ISO to provide all the services that has been mentioned above.</h6>

            

//             <div className='grid mx-[10%] gap-2 grid-cols-2 md:grid-cols-9 mt-10'>
//             {/* <Slider {...settings2}> */}
//                 <img src={cert1} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert2} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert3} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert4} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert5} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert6} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert7} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert8} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert9} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//             {/* </Slider> */}
//             </div>
//         </div>  


//     </div>
//   )
// }

// export default Home











//======>> Old 1

// import React,{useState,useRef,useEffect} from 'react';
// import {BsArrowLeftCircle,BsArrowRightCircle} from 'react-icons/bs';
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';
// import CountUp from 'react-countup';

// // clients 

// import client1 from '../images/clients/1.png';
// import client2 from '../images/clients/2.png';
// import client3 from '../images/clients/3.png';
// import client4 from '../images/clients/4.png';
// import client5 from '../images/clients/5.png';
// import client6 from '../images/clients/6.png';
// import client7 from '../images/clients/7.png';
// import client8 from '../images/clients/8.png';
// import client9 from '../images/clients/9.png';
// import client10 from '../images/clients/10.png';
// import client11 from '../images/clients/11.png';
// import client12 from '../images/clients/12.png';
// import client13 from '../images/clients/13.png';
// import client14 from '../images/clients/14.png';
// import client15 from '../images/clients/15.png';
// import client16 from '../images/clients/16.png';
// import client17 from '../images/clients/17.png';
// import client18 from '../images/clients/18.png';
// import client19 from '../images/clients/19.png';
// import client20 from '../images/clients/20.png';
// import client21 from '../images/clients/21.png';
// import client22 from '../images/clients/22.png';
// import client23 from '../images/clients/23.png';
// import client24 from '../images/clients/24.png';
// import client25 from '../images/clients/25.png';
// import client26 from '../images/clients/26.png';
// import client27 from '../images/clients/27.png';
// import client28 from '../images/clients/28.png';
// import client29 from '../images/clients/29.png';
// import client30 from '../images/clients/30.png';
// import client31 from '../images/clients/31.png';
// import client32 from '../images/clients/32.png';
// import client33 from '../images/clients/33.png';
// import client34 from '../images/clients/34.png';
// import client35 from '../images/clients/35.png';
// import client36 from '../images/clients/36.png';
// import client37 from '../images/clients/37.png';
// import client38 from '../images/clients/38.png';
// import client39 from '../images/clients/39.png';
// import client40 from '../images/clients/40.png';
// import client41 from '../images/clients/41.png';
// import client42 from '../images/clients/42.png';
// import client43 from '../images/clients/43.png';
// import client44 from '../images/clients/44.png';
// import client45 from '../images/clients/45.png';
// import client46 from '../images/clients/46.png';
// import client47 from '../images/clients/47.png';
// import client48 from '../images/clients/48.png';
// import client49 from '../images/clients/49.png';
// import client50 from '../images/clients/50.png';
// import client51 from '../images/clients/51.png';
// import client52 from '../images/clients/52.png';

// import Slider from "react-slick";

// // places 

// import health from '../images/industry/Healthcare.png';
// import education from '../images/industry/college.png';
// import industry from '../images/industry/industrial.png';
// import corperate from '../images/industry/corperate.png';
// import retial from '../images/industry/industrial.png';
// import pharmaceutical from '../images/industry/observation.png';
// import bank from '../images/industry/bank.png';
// import commercial from '../images/industry/building.png';

// import banner1 from '../images/banner/banner1.jpeg'


// // stand out

// import stand1 from '../images/stand_out/service_offering.png'
// import stand2 from '../images/stand_out/experienced_professionals.png'
// import stand3 from '../images/stand_out/hassle_execution.png'
// import stand4 from '../images/stand_out/diverse_offering.png'
// import stand5 from '../images/stand_out/client_testimonials.png'


// // services

// import ss from '../images/services/ss.png';
// import hs from '../images/services/hs.png';
// import se from '../images/services/se.png';

// //sections

// import section1 from '../images/section/infrastructure.png'
// import section2 from '../images/section/public-relation.png'
// import section3 from '../images/section/places.png'
// import section4 from '../images/section/like.png'


// //certificated 

// import cert1 from '../images/certificate/9001.jpg'
// import cert2 from '../images/certificate/14001.jpg'
// import cert3 from '../images/certificate/27001.jpg'
// import cert4 from '../images/certificate/45001.jpg'
// import cert5 from '../images/certificate/50001.jpg'
// import cert6 from '../images/certificate/CLRA.jpg'
// import cert7 from '../images/certificate/FCPLPsara.jpg'
// import cert8 from '../images/certificate/LICENSE CERTIFICATE.jpg'
// import cert9 from '../images/certificate/Sanitary.jpg'
// // import cert1 from '../../images/certificate/9001.pdf'
// // import cert1 from '../../images/certificate/9001.pdf'

// import about from '../images/fidelitus.jpeg'


// import {IoIosArrowBack,IoIosArrowForward} from 'react-icons/io';
// import {FiPlusCircle} from 'react-icons/fi';

// import Typist from 'react-typist';
// import { useNavigate } from 'react-router-dom';

// import videoPlay from '../images/video.mp4'
// import toast from 'react-hot-toast';

// function Home() {
 
//       const videoRef = useRef(null);

//       const navigator = useNavigate() 
//       const images = [banner1]

//       const [step,setstep] = useState(0)

//       useEffect(() => {
//         const video = videoRef.current;
//         if (video) {
//           // Attempt to play the video
//           video.play().catch(error => {
//            toast.error("Oops we couldn't play the video for you!")
  
//             // Handle error (e.g., show a play button)
//             console.log('Autoplay prevented. Showing play button.');
//           });
//         }
//     }, []);
  
//       const services = [
//         {
//           img:ss,
//           name:'Soft Service',
//           val:'We offer a wide range of facility services to suit your needs'
//         },
//         {
//           img:hs,
//           name:'Hard Services',
//           val:'We create an impact with our smart engineering services'
//         },
//         {
//           img:se,
//           name:'Security Services',
//           val:'With our trained security guard, the security service will be easy'
//         },
//       ]

//       const testimonials = [
//         {
//           id:1,
//           name:"Melvin D'Souza",
//           company:'MAVERIK',
//           testimonial:'We are associated with Fidelitus Corp Integrated Facility Services for last one year and we are very happy to recommend you to any other companies and very happy with your all services like security, housekeeping, and other highlight services with the team.',
//           img:client52,
//           date:'12 May 2022'
//         },
//         {
//           id:3,
//           name:'Sundari Rajan',
//           company:'Colive',
//           testimonial:'I have mention that over the last two years which probably are of the worst time of us Fidelitus FMS stood by us during the covid time shown a lot of solidarity and support will working with the team and also been very proactive in the team of approach support the great credit goes to Ms. Shubhalaxmi and entire team who is work very closely with our team to makesure of successful partnership, we are look for long association with them. Great work Fidelitus.',
//           img:client39,
//           date:'14 Jan 2023'
//         },
//         {
//           id:2,
//           name:'Raghav Suvarna',
//           company:'Softtek India pvt ltd',
//           testimonial:'We are working with Fidelitus Facility team since from 5 years. They are providing discipled service with great team work in our premises. They have very dedicated and competing team. We are happy to associate with Fidelitus Facility Team.',
//           img:client1,
//           date:'10 Jan 2022'
    
//         },
//       ]

//       const stand_out = [
//         {
//           img:stand1,
//           name:'Customer-Centric Approach',
//           val:'Your needs are at the heart of our solutions, ensuring personalized and effective services.'
//         },
//         {
//           img:stand2,
//           name:'Experienced Professionals',
//           val:'Our team of skilled experts guarantees unmatched proficiency in facility management.'
//         },
//         {
//           img:stand3,
//           name:'Hassle-Free Execution',
//           val:'We take full responsibility, ensuring smooth operations and minimal disruptions.'
//         },
//         {
//           img:stand4,
//           name:'Diverse Service Offerings',
//           val:'From security to landscaping, we offer a comprehensive range of facility management solutions.'
//         },
//         {
//           img:stand5,
//           name:'Client Testimonials',
//           val:'Our satisfied clients speak volumes about the quality of our services and dedication.'
//         },
//       ]

//       const industries = [
//          {
//             id:1,
//             img:health,
//             name:'Healthcare'
//          },
//          {
//           id:2,
//           img:education,
//           name:'Institutional'
//          },
//          {
//           id:3,
//           img:industry,
//           name:'Industrial'
//          },
//          {
//           id:4,
//           img:corperate,
//           name:'Corporate'
//          },
//          {
//           id:5,
//           img:retial,
//           name:'Retail'
//          },
//          {
//           id:6,
//           img:commercial,
//           name:'Commercial'
//          },
//         //  {
//         //   id:6,
//         //   img:'',
//         //   name:'Resedential'
//         //  },
//          {
//           id:7,
//           img:pharmaceutical,
//           name:'Pharmaceutical'
//          },
//          {
//           id:8,
//           img:bank,
//           name:'Bank'
//          },
//         //  {
//         //   id:9,
//         //   img:mall,
//         //   name:'Mall'
//         //  },

//       ]

//       const settings = {
//         dots: false,
//         arrows: true,
//         infinite: true,
//         speed: 100,
//         slidesToShow: 6,
//         slidesToScroll: 4,
//         initialSlide: 0,
//         centerMode: true,
//         cssEase: "linear",
//         autoplaySpeed: 2000,
//         centerPadding: '0px',
//         autoPlay:true,
//         prevArrow:<SampleNextArrow />,
//         nextArrow:<SamplePrevArrow />,
//         responsive: [
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               autoPlay:true
             
//             }
//           },
//           {
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               initialSlide: 3,
//               autoPlay:true
    
//             }
//           },
//           {
//             breakpoint: 480,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               initialSlide: 3,
//               autoPlay:true
//             }
//           }
//         ]
//       };
    
//       const settings1 = {
//         dots: false,
//         arrows: true,
//         infinite: true,
//         speed: 100,
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         initialSlide: 0,
//         centerMode: true,
//         cssEase: "linear",
//         autoplaySpeed: 2000,
//         centerPadding: '0px',
//         autoPlay:true,
//         prevArrow:<SampleNextArrow />,
//         nextArrow:<SamplePrevArrow />,
//         responsive: [
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               autoPlay:true
             
//             }
//           },
//           {
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 2,
//               initialSlide: 2,
//               autoPlay:true
    
//             }
//           },
//           {
//             breakpoint: 480,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1,
//               initialSlide: 1,
//               autoPlay:true
//             }
//           }
//         ]
//       };

     
//       function SampleNextArrow(props) {
//         const { className, style, onClick } = props;
//         return (
//         <BsArrowLeftCircle 
//         className={`${className} -mt-0  md:-mt-12 `}
//         style={{ ...style, display: "block",color:'#ddd',}}
//         onClick={onClick} />
//         );
//       }
      
//       function SamplePrevArrow(props) {
//         const { className, style, onClick } = props;
//         return (
//           <BsArrowRightCircle 
//               className={`${className} -mt-0 md:-mt-12 `}
//               style={{ ...style, display: "block",color:'#ddd',}}
//               onClick={onClick} />
//         );
//       }
  
//       const clients = [ 
//           {
//             id:1,
//             img:client1
//           },
//           {
//             id:2,
//             img:client2      
//           },
//           {
//             id:3,
//             img:client3
//           },
//           {
//             id:4,
//             img:client4
//           },
//           {
//             id:5,
//             img:client5
//           },
//           {
//             id:6,
//             img:client6
//           },
//           {
//             id:7,
//             img:client7
//           },
//           {
//             id:8,
//             img:client8
//           },
//           {
//             id:9,
//             img:client9
//           },
//           {
//             id:10,
//             img:client10
//           },
//           {
//             id:11,
//             img:client11
//           },
//           {
//             id:12,
//             img:client12
//           },
//           {
//             id:13,
//             img:client13
//           },
//           {
//             id:14,
//             img:client14
//           },
//           {
//             id:15,
//             img:client15
//           },
//           {
//             id:16,
//             img:client16
//           },
//           {
//               id:17,
//               img:client17
//             },
//             {
//               id:18,
//               img:client18     
//             },
//             {
//               id:19,
//               img:client19
//             },
//             {
//               id:20,
//               img:client20
//             },
//             {
//               id:21,
//               img:client21
//             },
//             {
//               id:22,
//               img:client22
//             },
//             {
//               id:23,
//               img:client23
//             },
//             {
//               id:24,
//               img:client24
//             },
//             {
//               id:25,
//               img:client25
//             },
//             {
//               id:26,
//               img:client26
//             },
//             {
//               id:27,
//               img:client27
//             },
//             {
//               id:28,
//               img:client28
//             },
//             {
//               id:29,
//               img:client29
//             },
//             {
//               id:30,
//               img:client30
//             },
//             {
//               id:31,
//               img:client31
//             },
//             {
//               id:32,
//               img:client32
//             },
//             {
//               id:33,
//               img:client33
//             },
//             {
//               id:34,
//               img:client34     
//             },
//             {
//               id:35,
//               img:client35
//             },
//             {
//               id:36,
//               img:client36
//             },
//             {
//               id:37,
//               img:client37
//             },
//             {
//               id:38,
//               img:client38
//             },
//             {
//               id:39,
//               img:client39
//             },
//             {
//               id:40,
//               img:client40
//             },
//             {
//               id:41,
//               img:client41
//             },
//             {
//               id:42,
//               img:client42
//             },
//             {
//               id:43,
//               img:client43
//             },
//             {
//               id:44,
//               img:client44
//             },
//             {
//               id:45,
//               img:client45
//             },
//             {
//               id:46,
//               img:client46
//             },
//             {
//               id:47,
//               img:client47
//             },
//             {
//               id:48,
//               img:client48
//             },
//             {
//               id:49,
//               img:client49
//             },
//             {
//               id:50,
//               img:client50
//             },
//             {
//               id:51,
//               img:client51
//             }
//       ]

//   return (
//     <div className='overflow-hidden max-w-sceen'>
//         {/* <Carousel 
//             centerMode={true} 
//             autoPlay={true} 
//             showStatus={false}
//             showThumbs={false}
//             showArrows={true}
//             swipeable={true}
//             autoFocus={true}
//             centerSlidePercentage={100}
//             showIndicators={false}
//             className=''
//             renderArrowPrev={(clickHandler, hasPrev) => {
//               return (
//                 <div
//                   className={`${hasPrev ? "opacity-100" : "opacity-20"} absolute right-[35px] border-r-2 border-gray-100 bottom-0 bg-white  flex justify-center items-center p-2  cursor-pointer z-20`}
//                   onClick={clickHandler}
//                 >
//                   <IoIosArrowBack size={20} className="text-black" />
//                 </div>
//               );
//             }}
//             renderArrowNext={(clickHandler, hasPrev) => {
//               return (
//                 <div
//                   className={`${hasPrev ? "opacity-100" : "opacity-20"} absolute right-0 bottom-0 bg-white  flex justify-center items-center p-2  cursor-pointer z-20`}
//                   onClick={clickHandler}
//                 >
//                   <IoIosArrowForward size={20} className="text-black" />
//                 </div>
//               );
//             }}
          
//           >
//               {images?.map((c,i)=>(
//                   <div key={i} className='text-center relative relative w-[100%] mx-auto focus:outline-none focus:ring-0'>
//                      <img alt={c} src={c}  className='w-full h-[35vh] md:h-[92.4vh] object-cover md:object-cover focus:outline-none focus:ring-0 '/>

//                      <div data-aos="fade-left" className='border-l-4 border-[#4190ac]  w-[75%]  md:w-[25%] pl-4 absolute top-[10%] right-[5%]'> 
//                           <h1 className='text-[20px] text-left font_thicker text-[#e58c3d]'>Fidelitus IFMS  </h1>
//                           <h6 className='text-left font_thick font-bold text-[15px] text-white'>A Global Integrated Facility Managment Services Provider</h6>
//                           <h6 className='text-left font_normal text-[13px] text-white'>As a recoginized IFMS We are ready to add care to your space</h6>
//                      </div>
//                   </div>    
//                ))}



             

//         </Carousel> */}

//         <video  ref={videoRef} id="video"  width="100%"  controls={false}  autoPlay playsInline loop muted className="w-full md:h-[90vh] object-cover">
//              <source src={videoPlay} type="video/mp4"/> 
//               {/* <source src={videoPlay1} type="video/mp4"/> */}
//             </video>


//         <div className='bg-[#418eaa]  py-10'>
//         <div className=' md:border-none grid grid-cols-2 md:grid-cols-4  ml-0 md:px-[10%]   md:mt-0   md:pt-0'>
//              <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 md:p-5'>
//                <img alt={section1} src={section1} className='w-20' />
//                <h6 className='text-center font_medium  text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={2.5} end={11} />+</h6>
//                <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Years In Industry</h6>
//              </div>

//              <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 border-l border-gray-100 md:p-5 md:border-r '>
//                <img alt={section2} src={section2} className='w-20' />
//                <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={2.5} end={80} />+</h6>
//                <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Clients Handling</h6>
//              </div>

//              <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 mt-4 border-r border-gray-100 md:mt-0 md:p-5 '>
//                <img alt={section3} src={section3} className='w-20' />
//                <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={4} end={800} />+</h6>
//                <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Man Power Exist</h6>
//              </div>

//              <div data-aos="fade-up" className='flex flex-col items-center justify-center p-2 py-5 mt-4 border-gray-100 md:mt-0 md:p-5'>
//                <img alt={section4} src={section4} className='w-20' />
//                <h6 className='text-center font_medium text-[30px] 2xl:text-[33px]'><CountUp enableScrollSpy={true} scrollSpyOnce={true} delay={1000} duration={5} separator="," end={100} />+</h6>
//                <h6 className='text-[12px] 2xl:text-[15px] text-center font-[900] font_normal text-slate-700 uppercase'>Client Satisfaction</h6>
//              </div>
//           </div>

//         </div>


//         <div className='py-20'>

//             <h6 data-aos="fade-right"  className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>About</span> Us</h6>
//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
           

//            <div  className='w-[90%] md:w-[80%] md:flex justify-between mt-16 mx-auto pb-10'>

//             <div data-aos="fade-right" className='md:w-[45%]' >
//                 <h6 className='border-l-4 border-[#e58c3d] pl-3 mx-auto text-slate-800 font-[700] text-[16px] 2xl:text-[19px] mt-2'>We&apos;re FMS Service Provider</h6>
//                 <h6 className='pl-4 mx-auto text-slate-800 font-[700] font_thicker text-[26px] 2xl:text-[29px] mt-2'>Our History and evolution as a FMS <span className='text-[#e58c3d]'> Service</span> Provider !. </h6>
//                 <h6 className='mx-auto break-word font_normal text-[15px] 2xl:text-[18px] mt-2 pl-3.5'>At Fidelitus, we have a decade of expertise in facility management services, empowering businesses to thrive in well-maintained environments. Our journey is built on a foundation of integrity, reliability, and innovation, making us a trusted partner for clients across diverse industries.</h6>

//                 <h6 onClick={()=>navigator('/about')} className='text-[12px] 2xl:text-[15px] font-[400] hover:bg-gray-200 ml-3 mx-1.5 cursor-pointer mt-5 pl-2  p-[4px] bg-gray-100 w-[100px] '>KNOW MORE</h6>
//             </div>
//             <div data-aos="fade-up" className='mt-10 md:mt-0 md:w-[45%] relative' >
//                  <img alt={about} src={about} />

//                  <div className='absolute w-[50%] top-[35%] left-[25%]'>
//                    {/* <Typist startDelay={1000}> */}
//                    <h6 className='text-center font_thicker text-[13px] 2xl:text-[16px]'>From last</h6>
//                    <h6 className='text-center font_thicker text-[30px] 2xl:text-[33px]'>10+ <span className='text-[10px]'>Years</span></h6>
//                    <h6 className='text-center font_thicker text-[13px] 2xl:text-[16px]'>Fumigation Service Provider</h6>
//                    {/* </Typist> */}
//                  </div>
//             </div>    

//             </div>

//         </div>

//         <div className='px-[10%] pt-16 border-t border-gray-100'>
//             <div className='md:w-[65%]'>
//               <h6 className='font_thicker text-[17px] 2xl:text-[20px] border-l-4 border-[#e58c3d] pl-4'>Why we stand Out in Facility Management Service</h6>
//               <div data-aos="fade-left" data-aos-delay="300" className='flex items-center justify-center w-full mt-1'>
//               <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//               <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//               </div>
//             </div>

//              <h6 data-aos="fade-left" className='font_normal text-[14.5px] 2xl:text-[17.5px] mt-4'> We excel in facility management due to our dedicated team, comprehensive solutions, and client-centric approach. Our expertise ensures efficient operations, cost-effectiveness, and optimal tenant experiences, setting us apart as leaders in the industry.</h6>

//              <div className='grid grid-cols-1 gap-2 my-10 md:grid-cols-5'>
//                 {stand_out?.map((s,i)=>(
//                   <div key={i} data-aos="fade-up" data-aos-delay="300" className='flex flex-col items-center justify-center p-4 border cursor-pointer'>
//                         <img alt={s?.img} src={s?.img} className='object-contain w-24 h-20 opacity-80' />
//                         <h6 className='font_thicker font-[900]  text-center  text-[13.5px] 2xl:text-[16.5px] mt-1.5'>{s?.name}</h6>
//                         <h6 className='font_normal text-[12px] 2xl:text-[15px] text-center '>{s?.val}</h6>
//                   </div> 
//                 ))}
//              </div>
//           </div>

//         <div className='py-20 bg-gray-50'>


//         <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>Our</span> Services</h6>
//             <div className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
//             <h6 className='text-center w-[80%] md:w-full mx-auto font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>The main sector we focus to provided 100% satisfaction to our clients.</h6>


//             <div className='w-[90%] md:w-[80%] mx-auto'>

//             <h6 data-aos="fade-left" className='text-[14px] 2xl:text-[17px] text-gray-700 font_normal mt-10'>An expertly managed and maintained workplace does more than deliver a pleasant experience. It makes work-life safer and more productive, and enjoyable. It is the difference between a place of work and a place where people can do their best work. And this is where Fidelitus IFMS comes into the picture.</h6>
//             <h6 data-aos="fade-left" className='text-[14px] 2xl:text-[17px] text-gray-700 font_normal mt-6'>From day-to-day services like housekeeping, pantry, and helpdesk services to pest control, security service, food & catering services, and electrical maintenance services, Fidelitus IFMS offers end-to-end facility management services for your business. Our mission is to provide best-in-class services while enabling cost efficiency.</h6>
           
//             <div className='grid grid-cols-1 gap-4 mt-10 md:grid-cols-3'>
//                {services?.map((s,i)=>(
//                 <div key={i} data-aos="fade-up" className='flex items-center justify-center p-3 bg-white rounded-md shadow-md cursor-pointer'>
//                    <img alt={s?.img} className='w-[90px]  h-[90px]' src={s?.img} /> 
//                    <div className='pl-3'>
//                    <h6 className='mt-2 2xl:text-[18px] font_thicker'>{s?.name}</h6>
//                    <h6 className='mt-1 text-gray-600 font_normal opacity-70 text-[14px] 2xl:text-[17px]'>{s?.val}</h6>
//                    </div>
//                 </div>   
//                ))}
//             </div> 

//             </div>
//         </div>

//         <div className='py-10'>
//             <h6 className='text-center font_medium text-[21px] 2xl:text-[24px] pt-10'>A Trusted clients of<span className='text-[#4190ac]'> Fidelitus FMS</span> Services</h6>
//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center font_normal justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center font_normal justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
//             <h6 className='text-center font_normal mt-2 text-black w-[90%] md:w-[70%] mx-auto text-[14.5px] 2xl:text-[17.5px]'>We provide businesses across the globe with the means to achieve their company expansion goals</h6>
 
//             <div className='w-[80vw]  mx-auto py-16'> 
//             <Slider {...settings}>
//                 {clients?.map((c)=>(
//                 <div key={c?.id} className='flex items-center justify-center focus:outline-none focus:ring-0'>
//                   <img alt={c?.img} className='focus:outline-none h-18 md:h-18 object-stretch focus:ring-0' src={c?.img}  />
//                 </div>
//                 ))}
//             </Slider>
//             </div> 

//         </div>

//         <div className='py-10 bg-gray-50'>
//             <h6 className='text-center font_medium text-[21px] 2xl:text-[24px] pt-10'>Our Client <span className='text-[#4190ac]'> Testimonials</span></h6>
//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
//             <h6 className='text-center font_normal mt-2 text-[14.5px] 2xl:text-[17.5px] mx-10'>The latest testimonials provided by our clients based on our services provided to them.</h6>

//             <div className='w-[80vw]  mx-auto py-10'> 
//             <Slider {...settings1}>
//                 {testimonials?.map((c)=>(
//                 <div data-aos="fade-up" key={c?.id} className='border-2 border-[#fafafa] rounded-md p-2 max-w-[95%]  mr-[2%] bg-white flex items-center justify-center focus:outline-none focus:ring-0'>
//                   <img alt={c?.img} className={`w-[100px] h-14 rounded object-contain flex items-start justify-start  focus:outline-none focus:ring-0`} src={c?.img}  />
//                   <div className='ml-3'>
//                     <h6 className='text-[14px] 2xl:text-[17px] font-[700] font_medium'>{c?.name}</h6>
//                     <h6 className='text-[12.5px] 2xl:text-[15.5px] font_normal text-slate-700 mt-1 '>{c?.testimonial}</h6>
//                   </div>
//                 </div>
//                 ))}
//             </Slider>
//             </div> 


//         </div>  

//         <div className='py-20'>


//         <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'> <span className='text-[#4190ac]'>Our reach spanning </span> across sectors </h6>
//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>
//             <h6 className='text-center  font_normal mt-2 text-[14.5px] 2xl:text-[15.5px] mx-10'>As one of the leading companies as Fidelitus IFMS service provider, we have a wide reach across sectors including, healthcare, corporate, educational institutions, and more.</h6>


//             <div className='w-[80%] mx-auto'>

           
//             <div className='grid grid-cols-3 gap-2 mt-10 md:grid-cols-8'>
//                {industries?.map((s,i)=>(
//                 <div key={i} data-aos="fade-up" className='grid items-center justify-center w-full'>
//                   <div>
//                    <img alt={s?.img} className={`${(s?.name === 'Pharmaceutical' || s?.name === 'Bank') && 'opacity-80'} object-contain  h-[65px]`} src={s?.img} /> 
//                    </div>
//                    <h6 className='mt-2 text-[13px] 2xl:text-[16px] text-center mb-4 font_thicker'>{s?.name}</h6>
//                 </div>   
//                ))}
//             </div> 

//             </div>
//         </div>  

//         <div className='py-20 bg-gray-50'>
//             <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>Frequently Asked  <span className='text-[#4190ac]'>Questions </span> </h6>

//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>

//             <h6 className='text-center  font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>The question that peoply ask us frequently and we response to them.</h6>


//             <div className='w-[80%] mx-auto py-16'>
//               <h6 data-aos-delay="100" data-aos="fade-right" onClick={()=>setstep(1)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> What are the benefits of effective facilities management?</h6>
//               <h6 className={`transition-all pl-6 duration-300 ${step === 1 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>Clean and hygienic premises, proper functioning of assets, and effective resource utilisation leading to reduction of repair and maintenance overheads, and happy employees are some of the benefits of effective facility management.</h6>

//               <h6 data-aos-delay="200" data-aos="fade-right" onClick={()=>setstep(2)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> Why is a facilities management company vital for your business?</h6>
//               <h6 className={`transition-all pl-6 duration-300 ${step === 2 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>A facility management company takes a load off your non-core activities, allowing you to focus on your core business area, delivering cutting-edge services and products to your clients. Expertise in facilities management enables better planning, and preventive measures are undertaken to improve the longevity of the asset and infrastructure, thereby reducing unwanted overheads and saving time.</h6>

//               <h6 data-aos-delay="300" data-aos="fade-right" onClick={()=>setstep(3)} className='cursor-pointer mb-2 font_thicker flex items-center 2xl:text-[18px]'><FiPlusCircle className='mr-2' /> what should I look for in a facilities management company?</h6>
//               <h6 className={`transition-all pl-6 duration-300 ${step === 3 ? 'transition duration-300 block' : 'transition-all hidden'} font_normal text-[14.5px] 2xl:text-[17.5px] py-2`}>While selecting a facility management partner, evaluate how do they score on the parameters of agility, technology, and scalability. In addition to that, learn how the company weather challenges and streamlines processes, the certifications received, and if they have the expertise to guide through unexpected challenges.</h6>


//             </div>
//         </div>  


//         <div className='py-20'>
//             <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>We are the certified  <span className='text-[#4190ac]'>IFMS </span> service provider</h6>

//             <div data-aos="fade-left"  className='flex items-center justify-center w-full mt-1'>
//             <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
//             <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
//             </div>

//             <h6 className='text-center mx-10 font_normal mt-2 text-[14.5px] 2xl:text-[17.5px]'>We are cerified as ISO to provide all the services that has been mentioned above.</h6>

            

//             <div className='grid mx-[10%] gap-2 grid-cols-2 md:grid-cols-9 mt-10'>
//             {/* <Slider {...settings2}> */}
//                 <img src={cert1} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert2} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert3} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert4} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert5} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert6} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert7} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert8} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//                 <img src={cert9} className='w-[100%] h-[160px] p-2 shadow object-cover md:object-contain' />
//             {/* </Slider> */}
//             </div>
//         </div>  


//     </div>
//   )
// }

// export default Home